import React, { useRef, useState } from "react";
import { Modal, Form, Input, message } from "antd";
import { addPharmacyConfigApi } from "../../../services/pharmacyConfigs.services";
import { nameRules } from "../common/validators";

const CompanyFormModal = ({ open, setOpen, onCreated }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const closeAndReset = () => {
    form.resetFields();
    setOpen(false);
  };

  const onFinish = (values) => {
    setLoading(true);
    addPharmacyConfigApi("companies", values)
      .then((res) => {
        message.success("Company added successfully");
        setLoading(false);
        closeAndReset();
        onCreated?.(res.data);
      })
      .catch((err) => {
        message.error(err?.response?.data?.message || "Failed to save company");
        setLoading(false);
      });
  };

  return (
    <Modal
      title="Add Company"
      open={open}
      onCancel={closeAndReset}
      centered
      width={420}
      destroyOnClose
      okText="Save"
      confirmLoading={loading}
      onOk={() => formRef.current?.submit()}
    >
      <Form layout="vertical" form={form} ref={formRef} onFinish={onFinish}>
        <Form.Item
          label="Name"
          name="name"
          rules={nameRules("Company")}
        >
          <Input placeholder="Company Name" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CompanyFormModal;
